import { post, get, upload } from '../../config/$ajax.js'

// 翻译
export const translateApi = function(data) {
  return post('/pddtemu/translate', data, {appJson: true, submitType: 'json'})
}
export const getLanguages = function(data) {
  return get('/pddtemu/translate/languages', data, { })
}